import { useEffect, useState } from 'react';
import { cn } from '../../../components/ui';
import { currentTheme, onThemeChange, toggleTheme, type Theme } from './theme';

/**
 * Light / dark switch for the staff header and the customer app header. `tone="shell"` suits the dark app
 * header (CustomerLayout); the default suits the white staff header.
 */
export function ThemeToggle({ tone = 'light', className }: { tone?: 'light' | 'shell'; className?: string }) {
  const [theme, setTheme] = useState<Theme>(() => currentTheme());
  useEffect(() => onThemeChange(setTheme), []);
  const dark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={() => setTheme(toggleTheme())}
      aria-label={dark ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-pressed={dark}
      title={dark ? 'Light theme' : 'Dark theme'}
      className={cn(
        'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md',
        tone === 'shell' ? 'text-slate-300 hover:bg-white/10' : 'text-slate-600 hover:bg-slate-100',
        className,
      )}
    >
      {dark ? (
        // Sun
        <svg aria-hidden viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      ) : (
        // Moon
        <svg aria-hidden viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
        </svg>
      )}
    </button>
  );
}

export default ThemeToggle;
